import { i18n, Row, Form, Cell } from "@common";
import { useState, useCallback, useRef, useImperativeHandle, forwardRef, useEffect } from "react";
import { adminService } from "@api";
import RichEditorReferenceImage from './RichEditorReferenceImage';

const Edit = (props) => {
    const { status, item, ...others } = props;

    const pageRef = useRef();

    const button = [
        {
            text: i18n.get("Common_Cancel_Entry"),
            name: "cancel",
            onClick: () => pageRef.current.onPanelButtonClick("cancel"),
        },
        {
            text: i18n.get("CIS_Admin_EmailTemplate_Edit_Preview_Entry"),
            name: "Preview",
            onClick: () => pageRef.current.onPanelButtonClick("Preview"),
        },
        {
            text: i18n.get("Common_Save_Entry"),
            classify: "info",
            name: "save",
            onClick: () => pageRef.current.onPanelButtonClick('save'),
        }];

    return (
        <R.Panel
            id="panel-emailTemplate-edit"
            title={i18n.get("Common_Edit_Entry")}
            status={status}
            buttons={button}
            willClose={() => pageRef.current.onPanelButtonClick('cancel')}
        >
            <Content {...others} ref={pageRef} item={item} />
        </R.Panel>
    );
};

const Content = forwardRef((props, refs) => {

    const [formItems, setFormItems] = useState({});
    const formRef = useRef();
    const aboutRef = useRef();

    const { item, reloadTable, onPreview } = props;

    useEffect(() => {
        if (item) {
            setFormItems({
                ...item,
                name: item.title,
            });
            aboutRef?.current.updateValue(item.content);
        }

    }, [item]);

    const onSave = useCallback(() => {
        if (!formRef.current.validate()) {
            return false;
        }
        let param = {
            Id: formItems.id,
            Subject: formItems.title,
            Content: formItems.content,
        };
        $$.loading(true);
        let fromOTP = false;
        formItems?.id?.indexOf('OTP') != -1 ? fromOTP = true : fromOTP = false;
        adminService.emailTemplateUpdate(param).then(request => {
            $$.loading(false);
            reloadTable(false, fromOTP ? i18n.get('CIS_Admin_EmailTemplate_Edit_TemplateName_OTP_Update_Message') : i18n.get('CIS_Admin_EmailTemplate_Edit_TemplateName_Welcome_Update_Message'));
        }).catch(e => {
            $$.loading(false);
            $$.toast(i18n.get('CIS_Admin_EmailTemplate_Edit_TemplateName_UpdateFailed_Message'), 'error');
            throw e;
        });
    }, [formItems, reloadTable]);


    const willClose = useCallback(() => {
        return formRef.current.areyousure.check();
    }, []);

    useImperativeHandle(refs, () => ({
        onPanelButtonClick: name => {
            switch (name) {
                case 'save':
                    return onSave();
                case 'Preview':
                    return onPreview(formItems);
                case 'cancel':
                    return willClose();
                default:
                    return false;
            }
        }
    }), [onSave, willClose, onPreview, formItems]);



    const handleCheckChange = (key, value) => {
        setFormItems(item => ({
            ...item,
            [key]: value
        }));
    };

    const doUpload = (args) => {
        setFormItems(item => ({
            ...item,
            ['content']: args
        }));
    };

    let templateType = formItems?.id?.substr(0, formItems?.id.indexOf(':'));
    switch (templateType) {
        case 'OTP':
            templateType = i18n.get('CIS_Admin_EmailTemplate_OTP_Entry');
            break;
        case 'WELCOME':
            templateType = i18n.get('CIS_Admin_EmailTemplate_Welcome_Entry');
            break;
        case 'RESET2FA':
            templateType = i18n.get('CIS_Admin_EmailTemplate_Reset2FA_Entry');
            break;
        case 'RESETPASSWORD':
            templateType = i18n.get('CIS_Admin_EmailTemplate_ResetPassword_Entry');
            break;
        default:
            break;
    }

    return (
        <Form ref={formRef}>
            <Row>
                <Cell label={i18n.get('CIS_Admin_EmailTemplate_Subject_Entry')} required validation="Input">
                    <R.Input
                        id="input-template-title"
                        type="text"
                        value={formItems.title}
                        onChange={(value) => handleCheckChange('title', value)}
                        attrs={{ 'aria-labelledby': Form.formlabel }}
                        placeholder={formItems.title}
                    />
                </Cell>
                <Cell label={i18n.get('CIS_Admin_EmailTemplate_TemplateType_Entry')} required validation="Input">
                    <R.Input
                        id="input-template-name"
                        type="text"
                        value={templateType}
                        onChange={(value) => handleCheckChange('name', value)}
                        attrs={{ 'aria-labelledby': Form.formlabel }}
                        disabled
                        placeholder={templateType}
                    />
                </Cell>
            </Row>
            <Row>
                <Cell label={i18n.get('CIS_Admin_EmailTemplate_Edit_Content_Entry')} required validation="RichEditor">
                    <RichEditorReferenceImage
                        ref={aboutRef}
                        value={formItems.content}
                        getEditorValue={doUpload}
                    />
                </Cell>
            </Row>
        </Form >
    );
});

export default Edit;